'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * [localStorageSet 目前对象值如果是函数 、RegExp等特殊对象存贮会被忽略]
 *
 * @param   {[type]}  key    [key 属性]
 * @param   {[type]}  value  [value 值]
 *
 * @return  {[type]}         [return description]
 */
var localStorageSet = exports.localStorageSet = function localStorageSet(key, value) {
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') value = JSON.stringify(value);
  localStorage.setItem(key, value);
};

/**
 * [localStorageGet 获取]
 *
 * @param   {[type]}  key  [key 属性]
 *
 * @return  {[type]}       [return description]
 */
var localStorageGet = exports.localStorageGet = function localStorageGet(key) {
  return localStorage.getItem(key);
};

/**
 * [localStorageRemove 移除]
 *
 * @param   {[type]}  key  [key 属性]
 *
 * @return  {[type]}       [return description]
 */
var localStorageRemove = exports.localStorageRemove = function localStorageRemove(key) {
  localStorage.removeItem(key);
};

/**
 * [localStorageSetExpire 存贮某一段时间失效]
 *
 * @param   {[type]}  key     [key 属性]
 * @param   {[type]}  value   [value 存贮值]
 * @param   {[type]}  expire  [expire 过期时间,毫秒数]
 *
 * @return  {[type]}          [return description]
 */
var localStorageSetExpire = exports.localStorageSetExpire = function localStorageSetExpire(key, value, expire) {
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') value = JSON.stringify(value);
  localStorage.setItem(key, value);
  setTimeout(function () {
    localStorage.removeItem(key);
  }, expire);
};

/**
 * [sessionStorageSet 存贮]
 *
 * @param   {[type]}  key    [key 属性]
 * @param   {[type]}  value  [value 值]
 *
 * @return  {[type]}         [return description]
 */
var sessionStorageSet = exports.sessionStorageSet = function sessionStorageSet(key, value) {
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') value = JSON.stringify(value);
  sessionStorage.setItem(key, value);
};

/**
 * [sessionStorageGet 获取]
 *
 * @param   {[type]}  key  [key 属性]
 *
 * @return  {[type]}       [return description]
 */
var sessionStorageGet = exports.sessionStorageGet = function sessionStorageGet(key) {
  return sessionStorage.getItem(key);
};

/**
 * [sessionStorageRemove 删除]
 *
 * @param   {[type]}  key  [key 属性]
 *
 * @return  {[type]}       [return description]
 */
var sessionStorageRemove = exports.sessionStorageRemove = function sessionStorageRemove(key) {
  sessionStorage.removeItem(key);
};

/**
 * [sessionStorageSetExpire 存贮某一段时间失效]
 *
 * @param   {[type]}  key     [key 属性]
 * @param   {[type]}  value   [value 存贮值]
 * @param   {[type]}  expire  [expire 过期时间,毫秒数]
 *
 * @return  {[type]}          [return description]
 */
var sessionStorageSetExpire = exports.sessionStorageSetExpire = function sessionStorageSetExpire(key, value, expire) {
  if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') value = JSON.stringify(value);
  sessionStorage.setItem(key, value);
  setTimeout(function () {
    sessionStorage.removeItem(key);
  }, expire);
};

/**
 * [cookieSet 存贮]
 *
 * @param   {[type]}  key     [key 属性]
 * @param   {[type]}  value   [value 值]
 * @param   {[type]}  expire  [expire 过期时间,单位天]
 *
 * @return  {[type]}          [return description]
 */
var cookieSet = exports.cookieSet = function cookieSet(key, value, expire) {
  var d = new Date();
  d.setDate(d.getDate() + expire);
  document.cookie = key + '=' + value + ';expires=' + d.toUTCString();
};

/**
 * [cookieGet 获取]
 *
 * @param   {[type]}  key  [key 属性]
 *
 * @return  {[type]}       [return description]
 */
var cookieGet = exports.cookieGet = function cookieGet(key) {
  var cookieStr = unescape(document.cookie);
  var arr = cookieStr.split('; ');
  var cookieValue = '';
  for (var i = 0; i < arr.length; i++) {
    var temp = arr[i].split('=');
    if (temp[0] === key) {
      cookieValue = temp[1];
      break;
    }
  }
  return cookieValue;
};

/**
 * [cookieRemove 删除]
 *
 * @param   {[type]}  key  [key 属性]
 *
 * @return  {[type]}       [return description]
 */
var cookieRemove = exports.cookieRemove = function cookieRemove(key) {
  document.cookie = encodeURIComponent(key) + '=;expires=' + new Date();
};
exports.default = {
  localStorageSet: localStorageSet,
  localStorageGet: localStorageGet,
  localStorageRemove: localStorageRemove,
  localStorageSetExpire: localStorageSetExpire,
  sessionStorageSet: sessionStorageSet,
  sessionStorageGet: sessionStorageGet,
  sessionStorageRemove: sessionStorageRemove,
  sessionStorageSetExpire: sessionStorageSetExpire,
  cookieSet: cookieSet,
  cookieGet: cookieGet,
  cookieRemove: cookieRemove
};